import React, { useState } from "react";

import styled from "styled-components";

import FormInput from "components/atoms/input/FormInput";
import useLoading from "components/atoms/loading/useLoading";
import Text from "components/atoms/text/Text";

import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddPubmedModal(props) {
    const [pubMedID, setPubMedID] = useState("");
    const { setLoading } = useLoading();

    const handleAddButton = () => {
        setLoading(true, "참고문헌 정보를 확인 중입니다.");
        props.mutation.mutate(
            {
                addFromSource: true,
                body: {
                    source: "pubmed",
                    source_id: pubMedID,
                },
            },
            {
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <Container>
            <Text variant="body-md">참고문헌 추가를 위해 PubMed ID를 입력해주세요.</Text>
            {/* PubMed ID로 참고문헌 추가 기능 */}
            <FormInput
                width="100%"
                margin="24px 0 0 0"
                label="PubMed ID"
                bgColor="var(--color-Base1)"
                borderless
                requiredMark
                rightInfoText="PubMed"
                tooltipMessage="PubMed ID는 생명과학 분야의 논문 정보를 제공하는 PubMed에서 각 논문에 부여되는 고유한 식별자 번호입니다."
                placeholder="EX) 33126180"
                onChange={(e) => setPubMedID(e.target.value)}
                onKeyDown={(e) => {
                    genericEnterKeyDown(e, () => {
                        handleAddButton();
                    });
                }}
                value={pubMedID}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
                disabled={!pubMedID}
            />
        </Container>
    );
}

export default ReferenceAddPubmedModal;
